import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import {
  CompanyTableCustomizationService,
  ContactTableCustomizationService,
  CrmFieldOptionsService,
  CrmFiltersService,
  CrmFormService,
  CrmObjectService,
  CrmTableStateService,
  CRMTrackingService,
  FieldOptionsInjectionToken,
  modelDrivenFormFieldOptionsInjectionTokenGenerator,
  ObjectType,
  OpportunityTableCustomizationService,
  PAGE_ROUTES,
  RestrictedGroupService,
  tableFiltersInjectionTokenGenerator,
  TranslateByObjectTypeService,
} from '@galaxy/crm/static';
import { GalaxyFilterChipInjectionToken } from '@vendasta/galaxy/filter/chips';
import { Routes } from '@angular/router';
import { PermissionsGuard } from '../../permissions-guard.service';

export const MULTI_LOCATION_CONTACT_ROUTES: Routes = [
  {
    path: '',
    redirectTo: PAGE_ROUTES.MULTI_LOCATION.CONTACTS.SUBROUTES.LIST,
    pathMatch: 'full',
  },
  {
    path: PAGE_ROUTES.MULTI_LOCATION.CONTACTS.SUBROUTES.LIST,
    loadComponent: () => import('./brand-crm-contacts.component').then((m) => m.BrandCrmContactsComponent),
    data: {
      objectType: 'contacts',
    },
  },
  {
    path: PAGE_ROUTES.MULTI_LOCATION.CONTACTS.SUBROUTES.PROFILE,
    loadComponent: () =>
      import('../../contact/contact-profile.component').then((m) => m.CrmContactProfilePageComponent),
    canActivate: [PermissionsGuard],
    data: {
      objectType: 'contacts',
    },
  },
  {
    path: PAGE_ROUTES.MULTI_LOCATION.CONTACTS.SUBROUTES.EDIT,
    loadComponent: () => import('../../contact/edit.component').then((m) => m.CrmEditContactComponent),
    canActivate: [PermissionsGuard],
    data: {
      objectType: 'contacts',
    },
  },
  {
    path: PAGE_ROUTES.PERMISSION_REQUIRED,
    loadComponent: () =>
      import('../../crm-components/permission-required/permission-required.component').then(
        (m) => m.PermissionRequiredComponent,
      ),
  },
];

const OBJECT_TYPE: ObjectType = 'Contact';

const CRM_PROVIDERS = [
  CompanyTableCustomizationService,
  ContactTableCustomizationService,
  CrmFieldOptionsService,
  CrmFiltersService,
  CrmFormService,
  CrmObjectService,
  CrmTableStateService,
  CRMTrackingService,
  OpportunityTableCustomizationService,
  RestrictedGroupService,
  TranslateByObjectTypeService,
];

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    CommonModule,
    GalaxyPageModule,
    ...CRM_PROVIDERS,
    {
      provide: GalaxyFilterChipInjectionToken,
      useFactory: tableFiltersInjectionTokenGenerator(OBJECT_TYPE),
    },
    {
      provide: FieldOptionsInjectionToken,
      useFactory: modelDrivenFormFieldOptionsInjectionTokenGenerator(OBJECT_TYPE),
    },
  ],
})
export class BrandCRMContactsModule {}
